var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "zgr4yin5pa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 0.403922 0 0 0 0 0.113725 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-175 -326) translate(175 326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8 4h13v2H8V4zM4.5 6.5C3.672 6.5 3 5.828 3 5s.672-1.5 1.5-1.5S6 4.172 6 5s-.672 1.5-1.5 1.5zm0 7c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5S6 11.172 6 12s-.672 1.5-1.5 1.5zm0 6.9c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWeek);
export default __webpack_public_path__ + "static/media/icons-week.5d525507388348239fadcfd3a0f41d77.svg";
export { ForwardRef as ReactComponent };